/**
 * Content toggle tabs - used on the new vehicle VDP
 * https://app.asana.com/0/848875433820573/1202160104097588/f
 */
((document) => {
  /**
   * Select all the elements to store
   */
  const tabs = document.querySelector('.js-content-toggle-tabs');
  const tabButtons = tabs.querySelectorAll('[role="tab"]');

  /**
   * Set the initial tab state, hide all content
   * and de-select all tabs
   */
  function setInitialTabState() {
    tabButtons.forEach((tab) => {
      tab.setAttribute('aria-selected', false);
    });
  }

  /**
   * Handle the tab state, hide/show, select/deselect states
   * @param {*} tab - The tab element
   * @param {boolean} setTab - True or false whether to select tab
   * @param {boolean} setHidden - True or false whether to hide the content
   */
  function handleTabsState(tab, setTab) {
    tab.setAttribute('aria-selected', setTab);
  }

  /**
   * Handle the tab click
   * @param {Event} event - The event from the mouse click
   */
  function handleTabClick(event) {
    setInitialTabState();

    event.currentTarget.setAttribute('aria-selected', true);
  }

  /**
   * Initialise the tabs
   */
  function initTabs() {
    const hasActiveClasses = tabs.querySelector('[class*="thisOne"]');

    setInitialTabState();

    tabButtons.forEach((tab) => {
      const hasActiveClass = tab.classList.contains('thisOne');
      if (hasActiveClasses && hasActiveClass) {
        handleTabsState(tab, true);
      } else {
        handleTabsState(tab, false);
      }

      tab.addEventListener('click', handleTabClick);
    });
  }

  vm.onload(initTabs);
})(document);
